import type { TransportModel } from "./transport";

export type ListingData = {
    dogName?: string;
    breedName?: string;
    ageLabel?: string;
    sexLabel?: string;
    sizeLabel?: string;
    sizeFromBreed?: boolean;
    weightRange?: string;
    coat?: string;

    mapSrc?: string;
    exercise?: string;
    lifespan?: string;
    trainability?: string;
    livingSpace?: string;
    goodWith?: string[];
    city?: string;
    distanceLabel?: string;
    distanceMiles?: number;
    priceLabel?: string;
    photos?: string[];
    fitPercent?: number | null;
    fitLine?: string;
    providerName?: string;

    providerId?: string;
    providerIsVerified?: boolean;
    healthTests?: string[];
    reportedHealth?: string[];
    completedCare?: string[];
    transports?: Array<{ label: string; sub?: string; price?: string }>;

    transportModel?: TransportModel;
    description?: string;
    descriptionQa?: Array<{ question: string; answer: string }>;

    avgLabel?: string;
    avgPrice?: string;
};

export function compact<T>(
    items: Array<T | false | 0 | "" | null | undefined>,
): T[] {
    return items.filter((item): item is T => Boolean(item));
}

export function goodWithValue(goodWith: string[] | undefined) {
    return goodWith
        ?.map((label, index) => (index ? label.toLowerCase() : label))
        .join(" & ");
}

export function joinParts(
    parts: Array<string | false | null | undefined>,
    separator = " · ",
): string | undefined {
    const kept = compact(parts);
    return kept.length > 0 ? kept.join(separator) : undefined;
}

export function listingHasDelivery(
    transports: ListingData["transports"],
): boolean {
    return (transports ?? []).some((t) =>
        /deliver|drop|transport|ship|van|flight|fly|nanny|air/i.test(t.label),
    );
}

export function listingOffersDelivery(listing: ListingData): boolean {
    const model = listing.transportModel;
    if (!model?.hasAny) return listingHasDelivery(listing.transports);
    return model.modes.some((mode) => mode.available && mode.kind !== "pickup");
}
